// Tiện ích dùng chung cho trang Quản lý Bình luận
import { format } from "date-fns";

const API_IMG_URL = process.env.REACT_APP_API_PUBLIC_URL || "";
const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || "";

// Một số postId cố định mở ở route riêng (khớp backend buildPostCommentPath)
const POST_PATH_BY_ID = { 10: "/shopee", 11: "/lazada", 12: "/tiktok", 17: "/post/videolist" };

export const fmtTime = (ts) => (ts ? format(new Date(Number(ts)), "dd/MM/yy HH:mm") : "—");

export const avatarUrl = (a) => (a ? `${API_IMG_URL}/img/users/${a}` : undefined);

export const postUrl = (postId, commentId) =>
    `${FRONTEND_URL}${POST_PATH_BY_ID[postId] || `/post/${postId}`}?comment=${commentId}`;

// Kết xuất danh sách bình luận đang hiển thị ra file CSV (tải về trình duyệt)
export function exportCommentsCsv(comments) {
    const header = ["ID", "PostId", "Người gửi", "Nội dung", "Số trả lời", "Ngày"];
    // Chặn CSV formula-injection: thêm dấu ' nếu ô bắt đầu bằng = + - @ (Excel/Sheets)
    const esc = (v) => {
        let s = String(v ?? "");
        if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
        return `"${s.replace(/"/g, '""')}"`;
    };
    const rows = comments.map((c) => [
        c.commentId,
        c.postId,
        c.user?.name || `#${c.user?.userId || ""}`,
        c.comment,
        c.replies?.length || 0,
        fmtTime(c.createTime),
    ]);
    const csv = [header, ...rows].map((r) => r.map(esc).join(",")).join("\n");
    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `binh-luan-${format(new Date(), "yyyyMMdd-HHmm")}.csv`;
    a.click();
    URL.revokeObjectURL(url);
}
